import { clsx, type ClassValue } from 'clsx';

/**
 * Utilitaire pour fusionner des classNames conditionnellement
 * Utilisé par tous les composants shadcn/ui
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
